import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CustomerReviewListRes;
export const CustomerReviewListTodo = createAsyncThunk('CustomerReviewList', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + `customer_ratting/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CustomerReviewListRes = res.data

    } catch (error) {
        return CustomerReviewListRes = error.response.data
    }
})

const CustomerReviewListSlice = createSlice({
    name: 'CustomerReviewList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CustomerReviewListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(CustomerReviewListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CustomerReviewListSlice.reducer; 